/* CAPRIMAFFIA — TERRACE / Notación
   Barra de avisos y barras de progreso de carrusel. Vanilla, sin dependencias. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ----------------------------------------------------------------------
     1. Barra de avisos
     Al cerrarla no vuelve durante la visita. Se guarda en sessionStorage y
     no en localStorage a propósito: en la siguiente visita vuelve a verse.
     ---------------------------------------------------------------------- */
  function initTopbar(root) {
    var bar = root.querySelector('[data-cm-topbar]:not([data-cm-ready])');
    if (!bar) return;
    bar.setAttribute('data-cm-ready', 'true');

    document.body.classList.add('cm-has-topbar');

    var key = 'cm-topbar:' + (bar.getAttribute('data-cm-key') || '');

    try {
      if (sessionStorage.getItem(key) === 'off') {
        document.body.classList.add('cm-topbar-off');
      }
    } catch (e) {
      /* navegación privada: la barra se queda */
    }

    var close = bar.querySelector('[data-cm-topbar-close]');
    if (!close) return;

    close.addEventListener('click', function () {
      document.body.classList.add('cm-topbar-off');
      try {
        sessionStorage.setItem(key, 'off');
      } catch (e) {
        /* sin almacenamiento: se cierra solo para esta pantalla */
      }
    });
  }

  /* ----------------------------------------------------------------------
     2. Barras de progreso de carrusel
     Se enganchan al slider de mundos que ya existe: leen sus botones y su
     estado, sin duplicar la lógica de navegación.
     ---------------------------------------------------------------------- */
  function initProgress(root) {
    root.querySelectorAll('[data-cm-prog]:not([data-cm-ready])').forEach(function (prog) {
      prog.setAttribute('data-cm-ready', 'true');

      var section = prog.closest('.cm-worlds');
      if (!section) return;

      var bars = Array.prototype.slice.call(prog.querySelectorAll('[data-cm-prog-bar]'));
      var pause = prog.querySelector('[data-cm-prog-pause]');
      var auto = parseInt(section.dataset.cmAutoplay || '0', 10);

      if (!auto || reduce.matches) prog.classList.add('cm-prog--static');
      else prog.style.setProperty('--cm-prog-dur', auto + 's');

      // El slider marca el slide activo en su contador; lo leemos de ahí
      var readout = section.querySelector('[data-cm-now]');

      function paint() {
        var current = readout ? parseInt(readout.textContent, 10) - 1 : 0;
        if (isNaN(current) || current < 0) current = 0;

        bars.forEach(function (bar, i) {
          bar.classList.toggle('is-done', i < current);
          bar.classList.remove('is-active');
          if (i === current) {
            // Reiniciar la animación de llenado
            void bar.offsetWidth;
            bar.classList.add('is-active');
          }
        });
      }

      // Cada barra salta a su slide
      bars.forEach(function (bar, i) {
        bar.addEventListener('click', function () {
          var dots = section.querySelectorAll('[data-cm-dot]');
          if (dots[i]) dots[i].click();
        });
      });

      if (readout && 'MutationObserver' in window) {
        new MutationObserver(paint).observe(readout, { childList: true, characterData: true, subtree: true });
      }

      if (pause) {
        pause.addEventListener('click', function () {
          var off = pause.getAttribute('aria-pressed') === 'true';
          pause.setAttribute('aria-pressed', off ? 'false' : 'true');
          pause.setAttribute('aria-label', off ? 'Pausar' : 'Reanudar');
          // El slider para al tener el puntero encima: reproducimos ese gesto
          section.dispatchEvent(new Event(off ? 'pointerleave' : 'pointerenter'));
          prog.classList.toggle('cm-prog--static', !off);
          paint();
        });
      }

      paint();
    });
  }

  /* ----------------------------------------------------------------------
     3. Altura real del grupo de cabecera
     El grupo entero va fijo, así que su alto depende de qué le metas dentro
     y de si la barra de avisos sigue abierta. Se mide en vivo y se publica
     en una variable para que el resto del tema deje el hueco justo.
     ---------------------------------------------------------------------- */
  function initHeadGroup() {
    var group = document.getElementById('header-group');
    if (!group) return;

    var root = document.documentElement;

    function measure() {
      var h = Math.round(group.getBoundingClientRect().height);
      var bar = group.querySelector('[data-cm-topbar]');
      var barH = bar ? Math.round(bar.getBoundingClientRect().height) : 0;

      // Con la barra encima, al retirarse el grupo entero sube: la barra sigue
      // midiendo lo mismo pero deja de ocupar pantalla, así que se descuenta.
      var lifted =
        document.body.classList.contains('cm-topbar-above') &&
        document.body.classList.contains('cm-topbar-hidden');

      if (barH > 0) root.style.setProperty('--cm-topbar-real-h', barH + 'px');
      if (lifted) h -= barH;
      if (h > 0) root.style.setProperty('--cm-headgroup-h', h + 'px');
    }

    measure();

    // Retirar la barra de avisos al bajar, devolverla al volver arriba.
    // El umbral lo decide el ajuste de la sección; si se desactiva, la barra
    // se queda fija junto al header.
    var ticking = false;

    function syncBar() {
      // Se lee en vivo: al cambiar el ajuste en el editor surte efecto ya
      var bar = group.querySelector('[data-cm-topbar]');

      // Encima: al retirarse, el header sube y se queda pegado arriba.
      // Debajo: la barra simplemente desaparece y el header no se mueve.
      var above = !bar || bar.getAttribute('data-cm-position') !== 'below';
      document.body.classList.toggle('cm-topbar-above', above);
      document.body.classList.toggle('cm-topbar-below', !above);

      if (!bar || bar.getAttribute('data-cm-hide-scroll') === 'false') {
        document.body.classList.remove('cm-topbar-hidden');
        measure();
        return;
      }

      var threshold = parseInt(bar.getAttribute('data-cm-hide-after'), 10);
      if (isNaN(threshold)) threshold = bar.offsetHeight + 40;

      var was = document.body.classList.contains('cm-topbar-hidden');
      var now = window.scrollY > threshold;

      if (was !== now) {
        document.body.classList.toggle('cm-topbar-hidden', now);
        // El hueco del contenido cambia justo al cruzar el umbral
        measure();
      }
    }

    // Al recargar a media página la barra no debe aparecer de golpe.
    // También se re-sincroniza en cada recarga de sección del editor.
    syncBar();

    // Los listeners se registran una sola vez aunque el editor recargue
    if (group.getAttribute('data-cm-ready') === 'true') return;
    group.setAttribute('data-cm-ready', 'true');

    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    // La barra puede cerrarse o retirarse: hay que volver a medir
    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(group);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          syncBar();
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function boot(root) {
    var scope = root || document;
    initTopbar(scope);
    initProgress(scope);
    initHeadGroup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
